import analyze from "../images/icons/reasons/account-tree.svg"
import technology from "../images/icons/reasons/new-releases.svg"
import optimizing from "../images/icons/reasons/speed.svg"
import speed from "../images/icons/reasons/flash-on.svg"
import personalization from "../images/icons/reasons/person.svg"
import design from "../images/icons/reasons/whatshot.svg"

export const reasons = [
  {
    title: "Trafne analizy",
    desc:
      "Przeprowadzimy audyt w Google który najlepiej odzwierciedli szybkość, sprawność i stabilne działanie twojej strony lub sklepu.",
    icon: analyze,
  },
  {
    title: "Najnowsze technologie",
    desc:
      "Wykorzystując najnowsze technologie, takie jak React.js czy Gatsby, przyśpieszmy działanie Twojej strony internetowej do 3 prędkości kosmicznej!",
    icon: technology,
  },
  {
    title: "Wydajna optymalizacja",
    desc:
      "Na czołowych audytach stron od Google, zyskasz 100 punktów. Zapewnimy wydajną optymalizację kodu oraz plików graficznych.",
    icon: optimizing,
  },
  {
    title: "Szybka realizacja",
    desc:
      "Skupiamy się wyłącznie na twoim projekcie. To pomaga nam osiągnąć największą efektywność i dokładność działań.",
    icon: speed,
  },
  {
    title: "Pełna personalizacja",
    desc:
      "Twoje sugestie i twoja wizja strony są dla nas priorytetem. W razie potrzeby pomożemy Ci dobrać odpowiednie rozwiązanie.",
    icon: personalization,
  },
  {
    title: "Nowoczesny design",
    desc:
      "Śledzimy najnowsze trendy w grafice komputerowej i interfejsach internetowych. Otrzymujesz design, który jest na szczycie popularności!",
    icon: design,
  },
]
